import React from "react";
import {QuoteContainer} from "../QuoteContainer";
import {Div10Inner} from "../../shopdrawing/div10/Div10";
import {Div10Switcher} from "./Div10Switcher";
import {WRAccessoryCutSheetBtn} from "./WRAccessoryCutSheetBtn";
import {TransferProducts} from "../hardware/TransferProducts";
import {Grid} from "@mui/material";
import {EventEmitter} from "nate-react-api-helpers";
import {ProjectPageTitle} from "../../shopdrawing/ProjectPageTitle";
import {MakeQuoteSubmittal} from "../../shopdrawing/div10/MakeSubmittal";

export const QuoteDiv10ForceUpdate = new EventEmitter<number>();
export function Div10() {
    const cacheBustKey = EventEmitter.reactValue(QuoteDiv10ForceUpdate);

    return (
        <QuoteContainer
            name={<Div10Switcher />}
                        actions={<>
                            <Grid item>
                                <MakeQuoteSubmittal />
                            </Grid>
                            <div style={{width: 8}} />
                            <Grid item>
                                <TransferProducts div10 />
                            </Grid>
                            <div style={{width: 8}} />
                            <Grid item>
                                <WRAccessoryCutSheetBtn />
                            </Grid>
                        </>}>
            <ProjectPageTitle title={"Div10"} />
            <Div10Inner key={cacheBustKey} />
        </QuoteContainer>
    )
}